/* eslint-disable no-console */
import { Workbox } from 'workbox-window';

export function register() {
    console.info('SW: Registering service worker...');

    if (!('serviceWorker' in navigator)) {
        console.warn('SW: Service workers are not supported in this browser.');
        return Promise.reject(new Error('Service workers not supported'));
    }

    return new Promise((resolve, reject) => {
        if (document.readyState === 'complete') {
            registerWorkbox().then(resolve).catch(reject);
        } else {
            window.addEventListener('load', () => {
                registerWorkbox().then(resolve).catch(reject);
            }, { once: true });
        }
    });
}

function registerWorkbox() {
    const wb = new Workbox('/service-worker.js');

    wb.addEventListener('installed', (event) => {
        if (event.isUpdate) {
            console.info('SW: New service worker installed, reloading page...');
            // Add small delay to ensure service worker is fully active
            setTimeout(() => window.location.reload(), 100);
        }
    });

    wb.addEventListener('waiting', () => {
        console.info('SW: Service worker is waiting to activate');
    });

    wb.addEventListener('controlling', () => {
        console.info('SW: Service worker is now controlling the page');
    });

    return wb.register()
        .then((registration) => {
            console.info('SW: Registration successful, scope:', registration.scope);
            return registration;
        })
        .catch((error) => {
            console.error('SW: Registration failed:', error);
            throw error;
        });
}

export function unregister() {
    console.info('SW: Unregistering service worker...');

    if (!('serviceWorker' in navigator)) {
        return Promise.resolve();
    }

    return navigator.serviceWorker.ready
        .then((registration) => registration ? registration.unregister() : false)
        .then((success) => {
            if (success) {
                console.info('SW: Unregistration successful.');
            } else {
                console.warn('SW: No registration found to unregister.');
            }
            return success;
        })
        .catch((error) => {
            console.error('SW: Unregistration failed:', error);
            throw error;
        });
}
